<script lang="ts" setup>
import { OrderFreightState } from "@/constants/order";
import { computed } from "vue";

const props = defineProps<{
  state: OrderFreightState;
}>();

const stateClass = computed(() => {
  if (props.state === OrderFreightState.updated) {
    return "bg-warning text-white";
  }

  if (props.state === OrderFreightState.new) {
    return "bg-success text-white";
  }

  return "";
});
</script>

<template>
  <v-chip
    :class="stateClass"
    class="text-uppercase font-size-11 rounded font-weight-600 px-2"
    density="compact"
    size="small"
  >
    {{ state }}
  </v-chip>
</template>

<style lang="scss" scoped></style>
